var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTimelineKey = function SvgTimelineKey(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    color: "#fff",
    viewBox: "0 0 42 42"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M25.228 4.104a12.784 12.784 0 0 0-12.17 16.636l-8.404 8.403a2.22 2.22 0 0 0-.597 1.978l.818 4.278a2.22 2.22 0 0 0 1.705 1.704l4.364.938a2.18 2.18 0 0 0 1.977-.614l2.54-2.54-3.648-3.528a1.33 1.33 0 0 1 0-1.824 1.296 1.296 0 0 1 1.807 0l3.682 3.546 4.04-4.04c1.264.419 2.588.632 3.92.63a12.784 12.784 0 0 0 0-25.567z",
    opacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M25.227 21.064a4.193 4.193 0 1 0 0-8.386 4.193 4.193 0 0 0 0 8.386"
  })));
};
export default SvgTimelineKey;